import React, { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import GooglePlacesAutocomplete, {
    geocodeByAddress,
    getLatLng
} from 'react-google-places-autocomplete';
import {
    FormControl,
    FormErrorMessage,
    FormLabel,
    Input,
    Textarea
} from '@chakra-ui/react';
import { DataContext } from '../../../core/contexts';
import LandService, { LandClass, LandInterface } from '../../../core/land';

export default function LandForm(props: {
    data?: any;
    onSubmit?: Function;
    setState?: Function;
}): React.ReactElement {
    const landService = new LandService();

    const { t, i18n } = useTranslation();
    const { lands, addLand, updateLand } = useContext(DataContext);

    const [land, setLand] = useState<LandInterface>({} as LandInterface);
    const [landError, setLandError] = useState({ name: false });
    const [isEdit, setEdit] = useState<boolean>(false);

    const isValid = (): boolean => {
        const isValid = land.name?.length;
        setLandError({
            name: !land.name
        });
        return !!isValid;
    };

    const saveLand = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        if (isValid()) {
            props.setState && props.setState(true);
            const saved = await landService.save(new LandClass(land));
            await (land.id ? updateLand(land.id) : addLand(saved as LandClass));
            props.setState && props.setState(false);
            props.onSubmit && props.onSubmit(saved, e);
        }
    };

    useEffect(() => {
        if (props.data?.id) {
            const json = props.data.toJSON();
            setLand({ ...json.data, id: json.id });
            setEdit(props.data !== undefined);
        }
    }, []);

    return (
        <form id='landForm' onSubmit={saveLand} noValidate>
            <FormControl
                isRequired
                isInvalid={landError.name}
                isDisabled={isEdit}
                mb='3'
            >
                <FormLabel htmlFor='name'>{t('common.name')}</FormLabel>
                <Input
                    id='name'
                    type='text'
                    isInvalid={landError.name}
                    defaultValue={land.name}
                    onChange={(e) => setLand({ ...land, name: e.target.value })}
                />
                <FormErrorMessage>{t('error.required')}</FormErrorMessage>
            </FormControl>
            <FormControl mb='3'>
                <FormLabel htmlFor='description'>
                    {t('common.description')}
                </FormLabel>
                <Textarea
                    id='description'
                    defaultValue={land.description}
                    onChange={(e) =>
                        setLand({ ...land, description: e.target.value })
                    }
                />
            </FormControl>
            <FormControl mb='3'>
                <FormLabel htmlFor='size'>{t('land.size')}</FormLabel>
                <Input
                    id='size'
                    type='number'
                    defaultValue={land.size}
                    onChange={(e) =>
                        setLand({ ...land, size: Number(e.target.value) })
                    }
                />
            </FormControl>
            <FormControl mb='3'>
                <FormLabel htmlFor='location'>{t('land.location')}</FormLabel>
                {/* <Input
                    id='location'
                    type='string'
                    defaultValue={land.location}
                    onChange={(e) =>
                        setLand({ ...land, location: e.target.value })
                    }
                /> */}
                <GooglePlacesAutocomplete
                    apiKey='AIzaSyApdCmbsGzUhZrdQtPy1TY8mGwwkHE4zzc'
                    apiOptions={{
                        language: i18n.language,
                        region: 'ES'
                    }}
                    selectProps={{
                        defaultInputValue: props.data?.location,
                        onChange: (e: any) => {
                            geocodeByAddress(e.label)
                                .then((results) => getLatLng(results[0]))
                                .then(({ lat, lng }) => {
                                    setLand({
                                        ...land,
                                        location: e.label,
                                        map: {
                                            type: land.map?.type || 'simple',
                                            data: land.map?.data || '',
                                            lat,
                                            lng
                                        }
                                    });
                                });
                        }
                    }}
                />
            </FormControl>
        </form>
    );
}
